/**
 * Parses a comma-separated list of checklist model template IDs from an
 * environment variable value. Invalid entries are dropped and duplicates
 * are removed while preserving order.
 */
export function parseOnboardingChecklistTemplateIds(raw: unknown): number[] {
  if (typeof raw !== "string" || raw.trim() === "") return [];
  const ids = raw
    .split(",")
    .map((part) => Number(part.trim()))
    .filter((id) => Number.isInteger(id) && id > 0);
  return [...new Set(ids)];
}

/**
 * Curated checklist model template IDs offered during self-serve onboarding,
 * configured via VITE_ONBOARDING_CHECKLIST_TEMPLATE_IDS (comma-separated).
 *
 * When the variable is not set (or contains no valid IDs), the "Checklists"
 * onboarding step is hidden entirely.
 */
export const ONBOARDING_CHECKLIST_TEMPLATE_IDS: readonly number[] =
  parseOnboardingChecklistTemplateIds(import.meta.env.VITE_ONBOARDING_CHECKLIST_TEMPLATE_IDS);

export const isOnboardingChecklistsStepEnabled = ONBOARDING_CHECKLIST_TEMPLATE_IDS.length > 0;
